import { 
  GET_PROJECTS,
  ADD_PROJECT,
  EDIT_PROJECT,
  DELETE_PROJECT,
  EXPORT_PROJECT,
  CLEAR_DATA,
  LOGOUT
} from '../action';

const initialState = {
  page: 0,
  totalPage: 0,
  totalProjects: 0,

  isGettingProjects: false,
  isGottenProjectsSuccess: false,
  isGottenProjectsFail: false,

  projects: [],

  isAddingProject: false,
  isAddedProjectSuccess: false,
  isAddedProjectFail: false,

  isEditingProject: false,
  isEditedProjectSuccess: false,
  isEditedProjectFail: false,

  isDeletingProject: false,
  isDeletedProjectSuccess: false,
  isDeletedProjectFail: false,

  isExporting: false,
  isExportedSuccess: false,
  isExportedFail: false,
  exportPercent: null,
  exportData: [],
  
};

export default (state = initialState, action) => {
  switch (action.type) {
    
    case GET_PROJECTS.REQUEST:
      return {
        ...state,
        isGettingProjects: true,
        isGottenProjectsSuccess: false,
        isGottenProjectsFail: false,
        projects: [],
      
      };
    case GET_PROJECTS.SUCCESS:
      return {
        ...state,
        isGettingProjects: false,
        isGottenProjectsSuccess: true,
        isGottenProjectsFail: false,
        projects: [...action.data.projects],
        page: action.data.page,
        totalPage: action.data.totalPage,
        totalProjects: action.data.totalProjects,
      };
    case GET_PROJECTS.FAIL:
      return {
        ...state,
        isGettingProjects: false,
        isGottenProjectsSuccess: false,
        isGottenProjectsFail: true,
        projects: [],
      };
    
    case ADD_PROJECT.REQUEST:
      return {
        ...state,
        isAddingProject: true,
        isAddedProjectSuccess: false,
        isAddedProjectFail: false,
      };
    case ADD_PROJECT.SUCCESS:
      return {
        ...state,
        isAddingProject: false,
        isAddedProjectSuccess: true,
        isAddedProjectFail: false,
        projects: [...action.data.projects],
        page: action.data.page,
        totalPage: action.data.totalPage,
        totalProjects: action.data.totalProjects,
      };
    case ADD_PROJECT.FAIL:
      return {
        ...state,
        isAddingProject: false,
        isAddedProjectSuccess: false,
        isAddedProjectFail: action.data.error ? false : true,
      };
    
    case EDIT_PROJECT.REQUEST:
      return {
        ...state,
        isEditingProject: true,
        isEditedProjectSuccess: false,
        isEditedProjectFail: false,
      };
    case EDIT_PROJECT.SUCCESS:
      return {
        ...state,
        isEditingProject: false,
        isEditedProjectSuccess: true,
        isEditedProjectFail: false,
        projects: [...action.data.projects],
        page: action.data.page,
        totalPage: action.data.totalPage,
        totalProjects: action.data.totalProjects,
      };
    case EDIT_PROJECT.FAIL:
      return {
        ...state,
        isEditingProject: false,
        isEditedProjectSuccess: false,
        isEditedProjectFail: action.data.error ? false : true,
      };

    case DELETE_PROJECT.REQUEST:
      return {
        ...state,
        isDeletingProject: true,
        isDeletedProjectSuccess: false,
        isDeletedProjectFail: false,
      };
    case DELETE_PROJECT.SUCCESS:
      return {
        ...state,
        isDeletingProject: false,
        isDeletedProjectSuccess: true,
        isDeletedProjectFail: false,
        projects: [...action.data.projects],
        page: action.data.page,
        totalPage: action.data.totalPage,
        totalProjects: action.data.totalProjects,
      };
    case DELETE_PROJECT.FAIL:
      return {
        ...state,
        isDeletingProject: false,
        isDeletedProjectSuccess: false,
        isDeletedProjectFail: action.data.error ? false : true,
      };
    
    case EXPORT_PROJECT.REQUEST: 
      return {
        ...state,
        isExporting: true,
        isExportedSuccess: false,
        isExportedFail: false,
        exportPercent: state.exportPercent === null || state.exportPercent === 100 ? 0 : state.exportPercent,
        exportData: state.exportPercent === 100 ? [] : state.exportData,
      };
    case EXPORT_PROJECT.SUCCESS: 
      return {
        ...state,
        isExporting: false,
        isExportedSuccess: true,
        isExportedFail: false,
        exportPercent: action.data.exportPercent,
        exportData: [...state.exportData, ...action.data.exportData],
      };
    case EXPORT_PROJECT.FAIL: 
      return {
        ...state,
        isExporting: false,
        isExportedSuccess: false,
        isExportedFail: true,
        exportPercent: null,
        exportData: []
      };
    case CLEAR_DATA:
      return {
        ...initialState,
      };
    case LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
